const mutations = {
  changeActivedIndex(state, payload) {
    state.activedIndex = payload;
  },
  saveAlApplicantInfo(state, payload) {
    state.applicantInfo = { ...payload };
  },
  saveAlPersonnel(state, payload) {
    state.personnel = { ...payload };
  },
  saveAlImplementation(state, payload) {
    state.implementation = { ...payload };
  },
  changeTabsIndex(state, payload) {
    state.tabsIndex = payload;
  },
};

export default mutations;
